<template>
  <FieldRow
    :name="name"
    :label="label"
    :description="description"
    :required="required"
    :tooltip="tooltip"
    :suggest="suggest"
    :warning="warning"
  >
    <template #default="{ componentField }">
      <Input
        v-bind="{ ...$attrs, ...componentField }"
        :type="type"
        :placeholder="placeholder"
        @blur="(event: FocusEvent) => emit('blur', event)"
      />
    </template>
    <template v-if="$slots.help" #help><slot name="help" /></template>
  </FieldRow>
</template>

<script setup lang="ts">
// A one-line text input. Attributes (autocomplete, data-testid, maxlength) go
// to the <input>. `blur` is its own emit rather than an attribute, because
// componentField carries vee-validate's own onBlur and the spread would drop a
// listener of the same name.
import { Input } from "@/components/ui/input";

import FieldRow from "./FieldRow.vue";
import type { FieldSuggest } from "./options";

defineOptions({ inheritAttrs: false });

const emit = defineEmits<{ blur: [FocusEvent] }>();

withDefaults(
  defineProps<{
    name: string;
    label: string;
    description?: string;
    required?: boolean;
    tooltip?: string;
    placeholder?: string;
    type?: "text" | "email" | "url" | "password" | "search" | "tel" | "datetime-local";
    suggest?: FieldSuggest;
    warning?: string;
  }>(),
  {
    description: undefined,
    tooltip: undefined,
    placeholder: undefined,
    type: "text",
    suggest: undefined,
    warning: undefined,
  },
);
</script>
